<template>
  <div class="btnGroup">
		<div class="row center">
			<a v-if="applyState == 'ing' " @click.prevent="dianzan" v-show="state == 'a'" href="###"   class="item btn " >
				 为你点赞
			</a>

			<a v-if="applyState == 'end' " @click.prevent v-show="state == 'a'" href="###"   class="item btn " >
				 活动已结束
			</a>

			<a v-if="applyState == 'start' " @click.prevent v-show="state == 'a'" href="###"   class="item btn " >
				 活动尚未开始
			</a>
		</div>


		<div class="row center">
			<a v-show="state == 'b'" href="###"   class="item btn " >
				 我也要免费申请
			</a>
		</div>

		<div class="row center">
			<a v-show="state == 'b'" href="###"   class="item btn " >
				 查看所有试用>>
			</a>
		</div>

		<div class="row center">
			<a v-show="state == 'b'" href="###"   class="item btn " >
				 查看所有试用
			</a>
		</div>
  </div>
</template>

<script>
import { EventBus } from "../event-bus.js";
import { mapState } from 'vuex'
export default {
  name: 'btnGroup',
  props : {
	state : String,
	activityId: String,
  },
  data(){
	  return {

	  }
  },
  created(){
	 //this.$store.commit('showQrCode');
  },
  methods: {
  	dianzan() {
		this.$router.push({
			path: '/detail/' + this.activityId
		})
		return;
  		this.$store.commit('showQrCode',`
https://www.dellemc-solution.com/campaigns/try/mobile-c/#/show/`+this.$route.params.id);
  	}
  },
  computed: {
  		... mapState([
			'applyState'
		])
  },
  components: {

  }
}
</script>

<style>
	.btnGroup{
		 width: 100%;
	}



	.btnGroup .row .item{
		flex-shrink: 1;
		align-items : center;
	}

	.btnGroup .row .item.btn{
		background-image: url('./../assets/btnBgRed.png');
		background-size: 100% auto;
		background-repeat: no-repeat;
		width: 1.768421rem;
		height: 0.336842rem;
		color: #fff;
		text-align: center;
		line-height: 0.336842rem;
		display: block;
	}

	.btnGroup .row.center{
		justify-content:center;
	}

</style>
